const GJIwmsUrl = "https://ipi.eprostor.gov.si/wms-si-gurs-kgi/ows/";

const allCommunalEquipmentList = [
    {
        name: "Cesta",
        layers: "SI.GURS.KGI:LINIJE_CESTE_G,SI.GURS.KGI:POLIGONI_CESTE_G,SI.GURS.KGI:TOCKE_CESTE_G",
        visible: false,
    },
    {
        name: "Električna energija",
        layers: "SI.GURS.KGI:LINIJE_ELEKTRICNA_ENERGIJA_G,SI.GURS.KGI:POLIGONI_ELEKTRICNA_ENERGIJA_G,SI.GURS.KGI:TOCKE_ELEKTRICNA_ENERGIJA_G",
        visible: true,
    },
    {
        name: "Komunikacije",
        layers: "SI.GURS.KGI:LINIJE_ELEKTRONSKE_KOMUNIKACIJE_G,SI.GURS.KGI:POLIGONI_ELEKTRONSKE_KOMUNIKACIJE_G,SI.GURS.KGI:TOCKE_ELEKTRONSKE_KOMUNIKACIJE_G,SI.GURS.KGI:CEVI,SI.GURS.KGI:LINIJE_ELEKTRONSKE_KOMUNIKACIJE_CEVI_G,SI.GURS.KGI:LINIJE_ELEKTRONSKE_KOMUNIKACIJE_KABLI_G",
        visible: true,
    },
    {
        name: "Kanalizacija",
        layers: "SI.GURS.KGI:LINIJE_KANALIZACIJA_G,SI.GURS.KGI:POLIGONI_KANALIZACIJA_G,SI.GURS.KGI:TOCKE_KANALIZACIJA_G",
        visible: true,
    },
    {
        name: "Letališča",
        layers: "SI.GURS.KGI:LINIJE_LETALISCA_G,SI.GURS.KGI:POLIGONI_LETALISCA_G,SI.GURS.KGI:TOCKE_LETALISCA_G",
        visible: false,
    },
    {
        name: "Nafta",
        layers: "SI.GURS.KGI:LINIJE_NAFTA_IN_NAFTNI_DERIVATI_G,SI.GURS.KGI:POLIGONI_NAFTA_IN_NAFTNI_DERIVATI_G,SI.GURS.KGI:TOCKE_NAFTA_IN_NAFTNI_DERIVATI_G",
        visible: false,
    },
    {
        name: "Odpadki",
        layers: "SI.GURS.KGI:LINIJE_RAVNANJE_Z_ODPADKI_G,SI.GURS.KGI:POLIGONI_RAVNANJE_Z_ODPADKI_G,SI.GURS.KGI:TOCKE_RAVNANJE_Z_ODPADKI_G",
        visible: false,
    },
    {
        name: "Optični priključki",
        layers: "SI.GURS.KGI:OPT_DELI_STAVB,SI.GURS.KGI:OPT_DELI_STAVB_G,SI.GURS.KGI:OPT_DELI_STAVB_H,SI.GURS.KGI:OPT_UPRAVLJAVCI,SI.GURS.KGI:POLIGONI_X_STAVBE,SI.GURS.KGI:POLIGONI_X_STAVBE_H,SI.GURS.KGI:TOCKE_X_STAVBE,SI.GURS.KGI:TOCKE_X_STAVBE_H,SI.GURS.KGI:UDELEZENCI_OPT,SI.GURS.KGI:UPRAVLJAVCI_X_OPT_DELI_STAVB,SI.GURS.KGI:UPRAVLJAVCI_X_OPT_DELI_STAVB_H",
        visible: false,
    },
    {
        name: "Pristanišča",
        layers: "SI.GURS.KGI:LINIJE_PRISTANISCA_G,SI.GURS.KGI:POLIGONI_PRISTANISCA_G,SI.GURS.KGI:TOCKE_PRISTANISCA_G",
        visible: false,
    },
    {
        name: "Toplotna energija",
        layers: "SI.GURS.KGI:LINIJE_TOPLOTNA_ENERGIJA_G,SI.GURS.KGI:POLIGONI_TOPLOTNA_ENERGIJA_G,SI.GURS.KGI:TOCKE_TOPLOTNA_ENERGIJA_G",
        visible: true,
    },
    {
        name: "Vodna infrastruktura",
        layers: "SI.GURS.KGI:LINIJE_VODNA_INFRASTRUKTURA_G,SI.GURS.KGI:POLIGONI_VODNA_INFRASTRUKTURA_G,SI.GURS.KGI:TOCKE_VODNA_INFRASTRUKTURA_G",
        visible: true,
    },
    {
        name: "Vodovod",
        layers: "SI.GURS.KGI:LINIJE_VODOVOD_G,SI.GURS.KGI:POLIGONI_VODOVOD_G,SI.GURS.KGI:TOCKE_VODOVOD_G",
        visible: true,
    },
    {
        name: "Zemeljski plin",
        layers: "SI.GURS.KGI:LINIJE_ZEMELJSKI_PLIN_G,SI.GURS.KGI:POLIGONI_ZEMELJSKI_PLIN_G,SI.GURS.KGI:TOCKE_ZEMELJSKI_PLIN_G",
        visible: true,
    },
    {
        name: "Žičnice",
        layers: "SI.GURS.KGI:LINIJE_ZICNICE_G,SI.GURS.KGI:POLIGONI_ZICNICE_G,SI.GURS.KGI:TOCKE_ZICNICE_G",
        visible: false,
    }
]

export { allCommunalEquipmentList, GJIwmsUrl };